import { getQrcodeInfo, setAppPassword, loginRequest } from "@/api/task";
import store from "@/store/index";
import NativeInstance from "./src/native";
import { getRandomId } from "@/utils";
const md5 = require("md5");
//扫描回调处理
const getScanResultCallback = function(data) {
    data = String(data);
    const qr = data.substr(data.indexOf("qr="), data.length).replace("qr=", "");
    getQrcodeInfo({
        qr: qr,
    }).then((res) => {
        res = res.data;
        if (res.code == 0) {
            const result = res.result;
            const userInfo = {
                userId: result.user_id,
                token: result.token,
                nickname: result.nickname,
            };
            store.dispatch("setUserInfo", userInfo);
            //显示设置手势密码UI
            store.dispatch("setScanUiType", 2);
            //也存到native
            window.nativeUtils.setData("token", userInfo.token);
            window.nativeUtils.setData("userId", userInfo.userId);
            window.nativeUtils.setData("nickname", userInfo.nickname);
        }
    });
};

//设置密码
const setPwd = function(pwd) {
    setAppPassword({
        password: pwd,
        os: store.state.app.platform == 1 ? "ios" : "android",
        token: store.state.user.token,
    }).then((res) => {
        res = res.data;
        if (res.code == 0) {
            store.dispatch("setIsSetPwd", 1);
            window.nativeUtils.setData("isSetPwd", 1);
            window.nativeUtils.setData("isLogin", 1);
            store.dispatch("setShowScanUI", false);
            //设置完密码直接开始进入游戏
            initApp(res.result);
        } else {
            store.dispatch("setQrErrorMsg", res.msg);
            //提交密码接口出错的时候，重置流程为重新设置密码
            window.handLockModel = 2;
        }
    });
};

//初始化APP加载需要的数据，并执行APP的逻辑
function initApp(data) {
    let appInfo = {
        identity: data.identity,
        channel_id: data.channel_id,
        domain: data.domain,
        server_type: data.server_type,
        style: data.style,
    };
    store.dispatch("setAppInfo", appInfo);
    const randomID = getRandomId(data.identity);
    store.dispatch("setRandomID", randomID);
    new NativeInstance().loadApp();
}

const login = function(pwd) {
    loginRequest({
        password: pwd,
        token: store.state.user.token,
        os: store.state.app.platform == 1 ? "ios" : "android",
    }).then((res) => {
        res = res.data;
        if (res.code == 0) {
            store.dispatch("setShowScanUI", false);
            window.nativeUtils.setData("isLogin", 1);
            //登录成功，直接开始进入游戏
            initApp(res.result);
        } else {
            store.dispatch("setQrErrorMsg", res.msg);
        }
    });
};

//type为1扫描，为2为忘记密码
const qrTool = {
    scan: function(type) {
        if (type == 2) {
            const userInfo = {
                userId: "",
                token: "",
            };
            store.dispatch("setUserInfo", userInfo);
            store.dispatch("setIsSetPwd", 0);
            store.dispatch("setScanUiType", 1);
            window.nativeUtils.setData("isLogin", 0);
            window.nativeUtils.setData("isSetPwd", 0);
            window.handLockModel = 2;
        }
        window.nativeUtils.getScanResult().then((res) => {
            getScanResultCallback(res);
        });
    },
    setPwd: function(p) {
        const pwd = md5(p);
        setPwd(pwd);
    },
    login: function(p) {
        const pwd = md5(p);
        login(pwd);
    },
};
export default qrTool;